// extracted by mini-css-extract-plugin
export default {"root":"CheckSession_root__xs50V","wrapperLogos":"CheckSession_wrapperLogos__HNEXq","mipLogo":"CheckSession_mipLogo__O682Q","wrapper":"CheckSession_wrapper__c0EXk"};